import { render } from "./CheckboxList.vue?vue&type=template&id=4e0b4ce8&scoped=true&ts=true"
import script from "./CheckboxList.vue?vue&type=script&lang=ts"
export * from "./CheckboxList.vue?vue&type=script&lang=ts"

import "./CheckboxList.vue?vue&type=style&index=0&id=4e0b4ce8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0b4ce8"]])

export default __exports__